<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">Help and Education</h2>
    </header>

    <div class="row">
        <div class="col-md-5 mx-auto text-center">
            <p>Coming soon with information about retirement.</p>
        </div>
    </div>
</template>
